import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DriverService } from '../../services/driver-service/driver.service';
import { MatDialog } from '@angular/material';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';
import { OutletContext } from '@angular/router';


@Component({
  selector: 'driver-select-box',
  templateUrl: './driver-select-box.component.html',
  styleUrls: ['./driver-select-box.component.css']
})
export class DriverSelectBoxComponent implements OnInit {

  constructor(private driverService:DriverService,private dialog:MatDialog) { }

  drivers:Array<any>;
  driverList = new Array<{id:number,text:string}>();
  driversPopulated = false;
  @Output() driverSelected: EventEmitter<any> = new EventEmitter();
  ngOnInit() {
    this.driverService.getDrivers().then((res:any) =>{
      if(res.status){
        this.drivers = res.data;
        this.drivers.forEach(d =>{
          this.driverList.push({
            id:d.driverid,
            text:d.firstname + ' ' + d.lastname
          });
        });
        this.driversPopulated = true;
        console.log(this.drivers);
        console.log(this.driverList);
      }else{
        new QuickDialog(this.dialog).InfoDialog(res.message,"Failed To Get Drivers","OK");
      }
    }).catch(e =>{
      new QuickDialog(this.dialog).InfoDialog(e,"Failed To Get Drivers","OK");
    });
  }

  public selected(value:any):void {
    this.driverSelected.emit(value);
    console.log('Selected value is: ', value);
  }

  public refreshValue(value:any):void {
  }

}
